import { Inject, Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map, mergeMap, tap } from 'rxjs/operators';
import { PermitRequestUpdateComponent } from '../components/permit-request-update/permit-request-update.component';
import { PermitsMetaDataItemNames, PermitEntity, PermitsMetaDataService, NoteTypeAllItems, PermitStatusAllItems, CodeValueInspectionResults, CodeValueInspectionState, RoInspectionsEntity, PermitRequestEntity, PermitRequestJobTypeLookup } from '../meta-data/permits-meta-data.service';
import { NotesRepositoryService } from '../../../shared/notes/services/notes-repository-service';
import {
    DwMetaDataRoutingService, DwMetaDataGridActionState, DwActionResult, DwMenuActionType,
    DwAction, DwActionType,
    DwGridActionResult,
    DwMdFormActionResult, DwMdFormActionHandler,
    DwMdFormActionState, DwQueryHelper,
    DwModalButtonStandardConfigs, DwModalConfig,
    DwModalService, DwModalSize, DwOrmDataService, DwOrmDataServiceToken, DwContext
} from '@devwareapps/devware-cap';


@DwAction({
    keyName: 'PermitsRequests_Create_Multiple',
    display: 'Permit Request - Create Multiple',
    actionType: DwActionType.formAction,
    isGlobal: true,
    parentItemName: [PermitsMetaDataItemNames.PermitRequest],
    defaultButtonConfig: {
        buttonClass: 'btn btn-warning mr-1 mt-1',
        buttonText: 'Create Multiple'
    },
    defaultSecurityConfig: {
        requireCanUpdate: false
    },
})
@Injectable()
export class PermitRequestCreateMultipleActionService implements DwMdFormActionHandler {

    constructor(
        private metaDataRoutingService: DwMetaDataRoutingService,
        private dwModalService: DwModalService,
        private notesRepository: NotesRepositoryService,
        @Inject(DwOrmDataServiceToken) private dataService: DwOrmDataService
    ) { }

    handleAction(formActionState: DwMdFormActionState): Observable<DwActionResult> {
        const permitRequest: PermitRequestEntity = formActionState.formApi.getFormData();

        const variableContext = this.getVariableContext(formActionState.context);

        // if it's not for the new Job Number type, save as usual (just in case)
        if (permitRequest.PermitRequestJobType == PermitRequestJobTypeLookup.WJID || permitRequest.PermitRequestJobType == PermitRequestJobTypeLookup.Opportunity) {

            return formActionState.formApi.saveData();
        }

        console.log(variableContext);

        const actionResult: DwMdFormActionResult = { success: false };

        return of(actionResult);
    }

    private getVariableContext(context: DwContext): PermitRequestVariableContext {
        for (let contextName in context) {
            if (context.hasOwnProperty(contextName)) {
                if (contextName.indexOf('variable_contex_') == 0) {
                    return context[contextName] as PermitRequestVariableContext;
                }
            }
        }

        return null;
    }
}


export interface PermitRequestVariableContext {
    JobNumber?: string;
    MassWJID?: number[];
}